import { heartbeat } from './inc/heartbeat';
import { isDateValid } from './inc/dates';

var _formResyncRequired = false;

(function ($) {


   window.$.fn.rlForms = function () {

      // Start heartbeat to keep session alive.
      heartbeat.start();

      /**
       * Custom Form Element: Google reCAPTCHA
       */

      window.renderGoogleRecaptchaFormElement = function () {
         $('[data-google-recaptcha]:visible').each(function () {
            var _this = this;
            grecaptcha.render(_this, {
               'sitekey': $(_this).attr('data-google-recaptcha'),
               'callback': function (response) {
                  $('#' + $(_this).attr('data-google-recaptcha-input-id')).val(response)
               }
            });
         });
      }

      // check for reCAPTCHA after step has changed.
      if (typeof $$epiforms !== 'undefined') {
         $$epiforms('.EPiServerForms').on('formsNavigateToStep', function (event, param1, param2) {
            setTimeout(function () {
               renderGoogleRecaptchaFormElement();
            }, 1000);
         });
      }


      if (typeof $$epiforms !== 'undefined') {
         $$epiforms(document).ready(function () {

            // Load Google reCAPTCHA script.
            $.getScript("https://www.google.com/recaptcha/api.js?onload=renderGoogleRecaptchaFormElement&render=explicit");

            // Front-end's basic validation.
            $.extend(true, epi.EPiServer.Forms, {
               Validators: {
                  'RoyalLondonGroup.CMS.Web.Business.Validation.RecaptchaValidator': function (fieldName, fieldValue, validatorMetaData) {
                     if (typeof fieldValue === 'string' && fieldValue.length > 0) {
                        return { isValid: true };
                     }
                     return { isValid: false, message: validatorMetaData.model.message };
                  },
                  'RoyalLondonGroup.CMS.Web.Business.Validation.MaximumFileSizeValidator': function (fieldName, fieldValue, validatorMetaData) {
                     if (fieldValue.length > 0) {
                        var totalSize = 0;
                        for (var i = 0; i < fieldValue.length; i++) {
                           totalSize += fieldValue[i].size;
                        }
                        if (totalSize > validatorMetaData.model.totalSizeInBytes) {
                           if (fieldValue.length === 1) {
                              return { isValid: false, message: validatorMetaData.model.message };
                           } else {
                              return { isValid: false, message: validatorMetaData.model.multipleFileValidationMessage };
                           }
                        }
                     }
                     return { isValid: true };
                  },
                  'RoyalLondonGroup.CMS.Web.Business.Validation.DateElementValidator': function (fieldName, fieldValue, validatorMetaData) {

                     var isValid = true;
                     const hiddenInput = $('[name=' + fieldName + ']');
                     const day = $('#' + fieldName + '_day');
                     const month = $('#' + fieldName + '_month');
                     const year = $('#' + fieldName + '_year');
                     const SplitDateFieldErrorMessage = "Please enter a valid date (DD/MM/YYYY).";

                     let dateParts = hiddenInput.val().split("/");
                     const dayValue = parseInt(dateParts[0], 10);
                     const monthValue = parseInt(dateParts[1], 10);
                     const yearValue = parseInt(dateParts[2], 10);

                     if(hiddenInput.is(':not([required])') && day.val() == '' && month.val() == '' && year.val() == '') {
                        return { isValid: true };
                     }

                     [day, month, year].forEach(function (field) {

                        let val = field.val();
                        let min = parseFloat(field.attr('min'));
                        let max = parseFloat(field.attr('max'));

                        // check if field is required.
                        if (field.is('[required]') && !val.length) {
                           isValid = false;
                           return;
                        }

                        // check if value is valid.
                        if (val.length > 0 && val < min || val > max) {
                           isValid = false;
                           return;
                        }

                     });

                     if (!isValid)
                        return { isValid: false, message: SplitDateFieldErrorMessage };

                     // create js date object for additional validation.
                     let date = new Date(yearValue, monthValue - 1, dayValue);

                     if ( !isDateValid(date, dayValue, monthValue, yearValue) )
                        return { isValid: false, message: SplitDateFieldErrorMessage };

                     return { isValid: true };

                  },
                  'RoyalLondonGroup.CMS.Web.Business.Validation.DateIsNotAfterTodayValidator': function (fieldName, fieldValue, validatorMetaData) {

                     // fix issue with fieldValue being set as only 'day' value.
                     fieldValue = $('[name=' + fieldName + ']').val();

                     // prevent validatation of invalid date strings.
                     if (!/^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[0-2])\/\d{4}$/.test(fieldValue)) {
                        return { isValid: true };
                     }

                     const [day, month, year] = fieldValue.split('/');
                     const dateSubmitted = new Date(`${month}/${day}/${year}`);
                     const today = new Date();

                     // check it's a valid date, and before tomorrow.
                     if(!isNaN(dateSubmitted) && dateSubmitted <= today) {
                        return { isValid: true };
                     }

                     return { isValid: false, message: validatorMetaData.model.message };
                  },
               },
            });

         });
      }

      /**
       * Date
       */
      $('[data-form-element-date]').each(function () {

         const $hiddenInput = $(this).find('input[type="hidden"]');
         let hiddenInputValue = $hiddenInput.val();
         let fieldName =  $hiddenInput.attr('name');
         const $day = $(this).find(`#${fieldName}_day`);
         const $month = $(this).find(`#${fieldName}_month`);
         const $year = $(this).find(`#${fieldName}_year`);
         const $inputs = $($day).add($month).add($year);

         // If the hidden fiels already, has a value then populate the fields.
         if (hiddenInputValue.length > 0)
         {
            $day.val( hiddenInputValue.substring(0, 2) );
            $month.val( hiddenInputValue.substring(3, 5) );
            $year.val( hiddenInputValue.substring(6, 10) );
         }

         // Prevent non-numeric characters being typed.
         $inputs.on("input", function() {
            let inputValue = $(this).val();
            let numericRegex = /^\d+$/;

            if (!numericRegex.test(inputValue)) {
               $(this).val(inputValue.replace(/\D/g, ""));
            }
         });

         // Format and update hidden input element.
         $inputs.on('change', function () {

            let $input = $(this);

            // format dd and mm fields (e.g. '01')
            if ($input.val().length > 0) {
               switch($input.attr('id')) {
                  case $day.attr('id'):
                  case $month.attr('id'):
                     $input.val( $input.val().padStart(2, '0') );
                     break;
               }
            }

            if($day.val().length && $month.val().length && $year.val().length)
            {
               $hiddenInput.val(`${$day.val()}/${$month.val()}/${$year.val()}`);
            } else {
               $hiddenInput.val('');
            }
         });

         // Change focus as the user types date.
         $inputs.on('input', function(e) {

            let $input = $(this);

            if( $input.val().length < parseFloat($input.attr('maxlength')) )
               return;

            switch($input.attr('id')) {
               case $day.attr('id'):
                  $month.focus().trigger('change');
                  break;
               case $month.attr('id'):
                  $year.focus().trigger('change');
                  break;
            }
         });
      });

      /**
       * Textbox
       */
      $(".Form__Element .Form__Element__ValidationError").each(function () {
         if ($(this).is(":visible")) {
            var addErrorClass = $(this).siblings('input');
            addErrorClass.addClass("errorValidation");
         }
      });

      /**
       * Radio & Checkbox Input Groups
       */

      // Radio & Checkbox Input Groups Layout Logic
      function inputhortizontalvertical() {
         $('.checkgroupcontainer').each(function () {
            $(this).removeClass('vertical');
            if ($(this).height() > $(this).children('.checkcontainer:first-of-type').height()) {
               $(this).addClass('vertical');
            }
         });
      }
      // Radio & Checkbox Multiline Label Checker
      function inputmultiline() {
         $('.checkgroupcontainer label').each(function (i) {
            let htmlfontsize = $('html').css('font-size');
            htmlfontsize = htmlfontsize.replace('px', '');
            htmlfontsize = Number(htmlfontsize);

            const square = htmlfontsize * 2;

            if ($(this).find('span').height() > square) {
               $(this).addClass('multilines');
            }
            else {
               $(this).removeClass('multilines');
            }
         });
      }

      var rlinputradioresizecheck;
      rlinputradioresizecheck = (function () {

         let stateCheck = setInterval(() => {
            if (document.readyState === 'complete') {
               clearInterval(stateCheck);

               elem = document.getElementById("main-content");
               let resizeObserver = new ResizeObserver(() => {

                  setTimeout(inputmultiline, 250);
                  setTimeout(inputhortizontalvertical, 250);

               });
               resizeObserver.observe(elem);
            }
         }, 250);
      });

      inputhortizontalvertical();
      inputmultiline();
      rlinputradioresizecheck();

      // Radio & Checkbox Hit Events
      $('.checkcontainer input[type=checkbox]').change(function () {
         if ($(this).is(":checked")) {
            $(this).next('label').addClass('checked');
         }
         else {
            $(this).next('label').removeClass('checked');
         }
      });
      $('.checkcontainer input[type=radio]').change(function () {
         $(this).parents('.checkgroupcontainer').find('label').removeClass('checked');
         if ($(this).is(":checked")) {
            $(this).next('label').addClass('checked');
         }
         else {
            $(this).next('label').removeClass('checked');
         }
      });


      //add focus to input label when input has focus
      $('.checkcontainer input[type=checkbox], .checkcontainer input[type=radio]').focusin(function () {
         $(this).next('label').addClass('focus');
      }).focusout(function () {
         $(this).next('label').removeClass('focus');
      });



      $('.FormSubmitButton').on('click', function () {
         const parentForm = $(this).parents('.EPiServerForms');
         const parentFormId = parentForm.attr('id');
         let headerStateHidden = false;

         //Scroll to top of thank you message when its available
         if ($('.Form__Status__Message').hasClass('Form__Success__Message')) {
            $('html, body').animate({
               scrollTop: $("form.EPiServerForms").first().offset().top
            }, 100);
         }

         //Scroll to top of error message when its available
         var statusMessageEl = document.querySelector('.Form__Status__Message');

         if (statusMessageEl) {            
            const observer = new MutationObserver(function (mutations) {
               mutations.forEach(function (mutation) {

                  if (mutation.type === 'attributes' && statusMessageEl.classList.contains('Form__Warning__Message')) {
                     smoothScroll();                     
                     observer.disconnect();
                  }
               });
            });

            observer.observe(statusMessageEl, {
               attributes: true
            });
         }

         //Bug: 325234
         //Sticky header overlapping field where focus lands as a result of validation trigger on click of submit
         if ($('#header').hasClass('nav-up')) {
            headerStateHidden = true;
         }
         setTimeout(function () {
            if ($('#' + parentFormId).hasClass('ValidationFail') && headerStateHidden) {
               $('#header').attr('data-formstate', 'FormValidationFail').attr('data-headstate', 'hidden');
            }
            else {
               $('#header').removeAttr('data-formstate');
            }
         }, 250);

      });

      /**
       * Helper Text (take out title tooltip)
       */

      var helpertextelements = $('.formcontainerblock .FormTextbox__Input, .formcontainerblock .FormSelection select, .FormChoice .formcontainerblock input, .Form__Element.FormChoice');
      helpertextelements.each(function () {
         $(this).attr('title', '');
      });

      /**
       * Hidden Selection Element
       */

      function setHiddenElementValue(element, $select) {
         var $inputElement = $(element).find("input.FormHiddenSelectionSummaryInput");
         var str = "";
         var count = 0;
         var includeChoice = $inputElement[0].hasAttribute("data-include-choice");
         var includeValue = $inputElement[0].hasAttribute("data-include-value");
         $select.children("option:selected").each(function () {
            if (!$(this)[0].hasAttribute("disabled")) {
               var choice = includeChoice ? $(this).text() : "";
               var value = includeValue
                  ? (!includeChoice ? $(this).val() : " (" + $(this).val() + ")")
                  : "";

               var comma = count === 0 ? "" : ", ";
               str += comma + choice + value;
               count++;
            }
         });
         $inputElement.val(str);
      }

      $(".FormHiddenSelectionSummary").each(function (index, element) {
         //get the previous form element
         var $selectDiv = $(element).prev(".FormSelection");
         //check that it exists
         if (typeof $selectDiv !== typeof undefined) {
            //find the select
            var $select = $selectDiv.find("select");
            if (typeof $select !== typeof undefined) {
               //set the hidden element if something is selected by default
               setHiddenElementValue(element, $select);
               //bind a change event to fill this element
               $select.on("change",
                  function () {
                     setHiddenElementValue(element, $select);
                  });
            }
         }
      });


      /**
       * File Upload
       */

      var uploadinput = $('.FormFileUpload input');

      uploadinput.on("focus", function () {
         $(this).prev('label').addClass('focus');
      });
      uploadinput.on("focusout", function () {
         $(this).prev('label').removeClass('focus');
      });

      var inputs = document.querySelectorAll('.FormFileUpload__Input');
      Array.prototype.forEach.call(inputs, function (input) {
         var label = input.previousElementSibling,
            labelVal = label.innerHTML;

         input.addEventListener('change', function (e) {
            var fileName = '';
            if (this.files && this.files.length > 1)
               fileName = (this.getAttribute('data-multiple-caption') || '').replace('{count}', this.files.length);
            else
               fileName = e.target.value.split('\\').pop();

            if (fileName)
               label.querySelector('span').innerHTML = fileName;
            else
               label.innerHTML = labelVal;
         });
      });

      //Submit button Ajax Loader for either stepped or non-stepped form
      if ($('[data-form-stepper-nav-submit]').length) {
         $('[data-form-stepper-nav-submit]').after('<img class="ajaxloader hide" alt="" src="/dist/assets/images/ajax-loader.v2.gif">');
      }
      else {
         $('button.FormSubmitButton').after('<img class="ajaxloader hide" alt="" src="/dist/assets/images/ajax-loader.v2.gif">');
      }

      if (typeof $$epiforms !== 'undefined') {

         // run ajax request asynchronously
         epi.EPiServer.Forms.AsyncSubmit = true;

         // listen to event when form submission begins
         $$epiforms(".EPiServerForms").on("formsStartSubmitting",
            function (data) {
               $('.ajaxloader').removeClass('hide');
            });

         // listen to event when form is successfully submitted
         $$epiforms(".EPiServerForms").on("formsSubmitted",
            function (data) {
               $('.ajaxloader').addClass('hide');
            });

         // formsSubmittedError
         $$epiforms(".EPiServerForms").on("formsSubmittedError",
            function (data) {
               $('.ajaxloader').addClass('hide');
            });
      }

      // TFS #195107: Bug - Not resetting file upload caption

      if (typeof $$epiforms !== 'undefined') {
         $$epiforms(document).ready(function () {
            $$epiforms(".EPiServerForms").on("formsReset", function (event, param1, param2) {
               $($$epiforms(this).get(0)).find('.FormFileUpload label span').html('&nbsp;');
            });

            // Fixed issue where the radio & checkbox input isn't visually updating on page refresh.
            $('.checkcontainer input[type=radio]:checked').parent('.checkcontainer').find('label').addClass('checked');
            $('.checkcontainer input[type=checkbox]:checked').next('label').addClass('checked');
         });
      }

      /**
       * Form Stepper: Fixes
       */

      // Fix: Remove data for optional steps that are unavailable.
      if (typeof $$epiforms !== 'undefined') {

         $$epiforms('.EPiServerForms').on('formsStartSubmitting', function (event) {

            var fieldsToBeExcluded = [];

            // loop through each step
            $(event.workingFormInfo.StepsInfo.Steps).each(function () {

               var step = this,
                  isStepAvailable = epi.EPiServer.Forms.Extension.isStepSatisfyDependentCondition(step, event.workingFormInfo),
                  formData = epi.EPiServer.Forms.Data.loadFormDataFromStorage(event.workingFormInfo.Id),

                  $stepInputs = $('#' + step.elementName + ' [data-f-datainput]').not("option, .FormStep,.FormSubmitButton,.Form__Element--NonData,[data-f-type='step'],[data-f-type='form'],[data-f-type='resetbutton'],[data-f-type='submitbutton'],[data-f-element-nondata]");

               if (formData === 'undefined') return;

               $stepInputs
                  .each(function (index, element) {
                     if (!isStepAvailable) {
                        delete formData[element.name]; // probably not necessary, as fields are excluded in the submission actor.
                        fieldsToBeExcluded.push(element.name);
                     }
                  });

            });

            document.cookie = '__RlFormFix__' + $('[name="__FormGuid"]').val() + '=' + fieldsToBeExcluded + ';path=/;domain=' + window.location.hostname + '';

         });
      }

      // Fix: Add aria-expanded attribute to prevent screen-reader reading non-visible steps.
      if (typeof $$epiforms !== 'undefined') {
         $('.EPiServerForms').on('rlFormsFixAria', function () {
            $('[data-f-type="step"]').each(function () {
               var $step = $(this);
               setTimeout(function () {
                  $step.attr('aria-expanded', ($step.hasClass('hide')) ? 'false' : 'true');
               }, 350);
            });
         });

         $(document).ready(function () {
            $('.EPiServerForms').trigger('rlFormsFixAria');
         });

         $$epiforms('.EPiServerForms').on('formsSubmitted formsNavigateToStep', function () {
            $('.EPiServerForms').trigger('rlFormsFixAria');
         });
      }

      /**
       * Form Stepper: Customised UI
       */

      $('[data-f-type="step"]').eq(0).each(function () {

         var $form = $(this).closest('form.EPiServerForms'),
            $steps = $form.find('[data-form-stepper-steps]'),
            $stepsDescription = $form.find('[data-form-stepper-description]'),
            $stepAccessibleProgress = $form.find('[data-form-stepper-progress]'),
            $anchorTop = $form.find('[data-form-top]'),
            $buttonPrev = $form.find('[data-form-stepper-nav-prev]'),
            $buttonNext = $form.find('[data-form-stepper-nav-next]'),
            $buttonSubmit = $form.find('[data-form-stepper-nav-submit]'),
            $buttonPrevOriginal = $form.find('button[data-f-navigation-previous]'),
            $buttonNextOriginal = $form.find('button[data-f-navigation-next]'),
            $accessibleStepHeader = $form.find('#accessibleStepHeader'),
            $progress = $form.find('#progress');

         // don't run script if there is only one step.
         if ($form.find('[data-f-type="step"]').length < 2) { return; }

         $buttonPrev.on('click',
            function (e) {
               e.preventDefault();
               //Prevent ValidationFail border colour being displayed when user navigates to a previous step and then returns.
               $('div.ValidationFail').removeClass('ValidationFail');
               $buttonPrevOriginal.click();
               smoothScroll();
               $form.trigger('form-stepper-nav--update', [$buttonPrev]);
            });

         $buttonNext.on('click',
            function (e) {
               e.preventDefault();
               $buttonNextOriginal.click();
               smoothScroll();
               $form.trigger('form-stepper-nav--update');
            });

         $buttonSubmit.on('click', function (e) {
            e.preventDefault();

            if (_formResyncRequired) {
               $form.trigger('form-resync');
               return;
            }

            heartbeat.ping(
               function () {
                  $form.find('[data-f-type="step"]:not(.hide) button[data-f-type="submitbutton"]').click();
               },
               function () {
                  $form.trigger('form-resync');
               },
               function () {
                  $form.trigger('form-resync');
               }
            );

            $form.trigger('form-stepper-nav--update');

            /*Set stepper side bar to show all steps completed on successful submission
            and empty the sr-only progress*/
            if ($.trim($('[data-f-form-statusmessage]').html()).length > 0) {
               setTimeout(function () {
                  $('.form-stepper-steps .rl-node:last-of-type').removeClass('active');
                  $stepAccessibleProgress.empty();
                  $stepsDescription.empty();
               },
                  350);
            }

            smoothScroll();

         });

         $(window).on('form-resync', function () {
            alert('We need to refresh the page to synchronise your form data. \n\nPlease be aware that you\'ll be taken back to step 1, and you\'ll need to enter some of your information again. \n\nWe\'re sorry for any inconvenience this may cause.');
            location.reload();
         });

         $(window).on('form-resync-required', function () {
            _formResyncRequired = true;
         });


         $form.on('form-stepper-nav--update', function (event, source) {

            /* accessible validation */

            updateAccessibleValidation();

            /* navigation buttons */

            var $currentSubmitButton = $form.find('[data-f-type="step"]:not(.hide) button[data-f-type="submitbutton"]');
            $currentSubmitButton.hide();

            $buttonPrev.attr('disabled',
               ($buttonPrevOriginal.attr('disabled') && $buttonPrevOriginal.attr('disabled').length) ? true : false
            );

            if ($buttonPrev.is('[disabled=disabled]')) {
               $('nav.my-3').attr('aria-hidden', 'true').hide();
            }
            else {
               $('nav.my-3').attr('aria-hidden', 'false').show();
            }

            $buttonNext.attr('disabled',
               ($buttonNextOriginal.attr('disabled') && $buttonNextOriginal.attr('disabled').length) ? true : false
            );

            $buttonSubmit.attr('disabled',
               ($currentSubmitButton.length) ? false : true
            );

            $buttonSubmit.text(
               $currentSubmitButton.text()
            );

            $buttonSubmit.attr('title',
               $currentSubmitButton.attr('title')
            );


            /* stepper desktop view */

            var stepsHtml = '';
            $form.find('section[data-f-type="step"]').each(function (i) {
               var activeStepClass = (!$(this).hasClass('hide')) ? 'active' : '',
                  stepLabel = $(this).find('.FormStep__Title').text();
               stepsHtml += '<span role="tab" class="rl-node ' + activeStepClass + '"><span class="stroke" aria-hidden="true"></span>' + ((stepLabel.length) ? stepLabel : 'Step ' + (i + 1)) + '</span>';
            });

            $steps.html(
               '<div aria-orientation="vertical" class="nav flex-column rl-stepper linear-mode" role="tablist" aria-hidden="true">' + stepsHtml + '</div>'
            );

            /* stepper mobile view */

            var $formSteps = $form.find('[data-f-type="step"]'),
               $currentFormStep = $formSteps.filter(':not(.hide)'),
               currentStepIndex = $formSteps.index($currentFormStep) + 1;

            $stepsDescription.html(
               '<div class="mb-3">Step <strong>' + currentStepIndex + '</strong> of ' + $formSteps.length + '</div>'
            );

            if (currentStepIndex > 1) {

               $stepAccessibleProgress.html('<div class="sr-only"> The form is ' +
                  parseInt((100 * (currentStepIndex - 1)) / ($formSteps.length)) +
                  ' percent complete</div>');

               //source will only be defined if coming from back button
               if (typeof source == 'undefined') {
                  getfocusonelement(); //set focus on first form element on step > than 1
               }
            }


            $accessibleStepHeader = $form.find('#accessibleStepHeader');
            var stepTitle = $currentFormStep.find('.FormStep__Title').text();

            if ($accessibleStepHeader.text() != stepTitle) {

               $accessibleStepHeader.empty();
               $accessibleStepHeader.text(stepTitle);

            }

            //set height of the node stroke span
            $('.rl-stepper .rl-node').each(function () {
               stepperstroke(this);
            });

         });

         $$epiforms('.EPiServerForms').on('formsSetupCompleted formsSubmitted', function () {
            $form.trigger('form-stepper-nav--update');
            setTimeout(function () {
               $form.trigger('form-stepper-nav--update');
            }, 350);
         });

         $('.FormResetButton').on('click', function (e) {
            $buttonSubmit.attr('disabled', true);
            setTimeout(function () {
               $form.trigger('form-stepper-nav--update');
            }, 350);
         });

         setTimeout(function () {
            $form.trigger('form-stepper-nav--update');
         }, 350);

      });

      var rlstepperlinesizecheck;
      rlstepperlinesizecheck = (function () {

         let stateCheck = setInterval(() => {
            if (document.readyState === 'complete') {
               clearInterval(stateCheck);

               elem = document.getElementById("main-content");
               let resizeObserver = new ResizeObserver(() => {

                  setTimeout(function () {
                     //reset height of the node stroke span
                     $('.rl-stepper .rl-node').each(function () {
                        stepperstroke(this);
                     });
                  }, 250);

               });
               resizeObserver.observe(elem);
            }
         }, 250);
      });

      rlstepperlinesizecheck();

      function stepperstroke(el) {
         var thisnode = $(el).innerHeight(),
            prevnode = $(el).prev('.rl-node').height(),
            dotspacing = 10;

         let htmlfontsize = $('html').css('font-size');
         htmlfontsize = htmlfontsize.replace('px','');
         htmlfontsize = Number(htmlfontsize);

         let padding = htmlfontsize * 2;

         $(el).find('.stroke').css('height', padding + prevnode).css('bottom', thisnode - padding - dotspacing);
      }

      function getfocusonelement() {
         //Get first navigable control
         var $stepControlForFocus = $('[data-f-type="step"]:not(.hide) [data-f-datainput]:not(.hide)').not(
            "option, .FormStep,.FormSubmitButton,.Form__Element--NonData,[data-f-type='step'],[data-f-type='form'],[data-f-type='resetbutton'],[data-f-type='submitbutton'],[data-f-element-nondata]")
            .first();

         if ($stepControlForFocus.length) {
            $stepControlForFocus.focus();
         }
         else {

            var $recaptchaForFocus = $('[data-google-recaptcha-input-id]');

            if ($recaptchaForFocus.length) {
               $recaptchaForFocus.focus();
            } else {
               $('[data-form-top]').focus();
            }
         }
      }

      function updateAccessibleValidation() {
         var $validationSource = $('.FormStep:not(.hide) .Form__Element__ValidationError:not(:empty):visible').clone();



         if ($validationSource.length > 0) {

            setTimeout(function () {
               /* Set to first error here */
               var focusInputName = $validationSource[0].getAttribute('data-f-linked-name');
               var recaptchaFocusInputName = document.getElementById(focusInputName);
               var focusInput = recaptchaFocusInputName !== null ? recaptchaFocusInputName : document.getElementsByName(focusInputName)[0];

               focusInput.focus();


            }, 600)

         }
      }

      function smoothScroll() {
         var headerHeight;
         
         if ($(window).width() <= 767.98) {
            headerHeight = 80;
         } else if ($(window).width() <= 991.98) {
            headerHeight = 110;
         } else {
            headerHeight = 120;
         }
         //767.98 and 991.98 taken from bs4's media-breakpoint-up media queries
         
         // Using jQuery's animate() method to add smooth page scroll
         // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
         $('html, body').stop().animate({
            scrollTop: $('#formBlockTop').offset().top - headerHeight
         }, 800, 'swing');
      }

      /**
      * Submit button
      */
      $('<span class="arrow"></span>').appendTo(".Form__Element.FormSubmitButton");


      /*** INLINE VALIDATION ***/
      /*** feature update aug 2023 ***/

      if (typeof $$epiforms !== 'undefined') {

         const _form = epi.EPiServer.Forms[$$epiforms(".EPiServerForms")[0].id],
            commonformSelector = $('.Form__Element input[type=text], .Form__Element input[type=number], .Form__Element textarea, .Form__Element select'),
            selectSelector = $('.Form__Element select'),
            radioCheckboxSelector = $('.Form__Element .checkgroupcontainer .checkcontainer input[type=radio], .Form__Element .checkgroupcontainer .checkcontainer input[type=checkbox]'),
            inputformSelector = $('.Form__Element input[type=text], .Form__Element input[type=number], .Form__Element textarea').not('.Form__Element input[type=text].datefield'),
            fileUploadElement = $('.Form__Element input[type=file]'),
            newDateFieldSelector = $('.Form__Element input[type=text].datefield'),
            inputNumberSelector = $('.Form__Element input[type=number]');

         //majority of form elements
         commonformSelector.on('focusout', function () {
            const thisID = $(this).attr('id');
            _form.ValidationInfo.forEach(function (item) {
               if (item.targetElementId === thisID) {
                  validateElement(item.targetElementName, item.validators, $("#" + item.targetElementId).val());
               }
            });
         });

         //number form type
         inputNumberSelector.on('change click', function (e) {
            const thisID = $(this).attr('id');
            if (e.type === 'click' && $("#" + thisID).val() == '') {
               ///do nothing
            }
            else if (e.type === 'change') {
               _form.ValidationInfo.forEach(function (item) {
                  if (item.targetElementId === thisID) {
                     validateElement(item.targetElementName, item.validators, $("#" + item.targetElementId).val());
                  }
               });
            }
         });

         //Select Field on change
         selectSelector.on('change', function () {
            const thisID = $(this).attr('id');
            _form.ValidationInfo.forEach(function (item) {
               if (item.targetElementId === thisID) {
                  validateElement(item.targetElementName, item.validators, $("#" + item.targetElementId).val());
               }
            });
         });

         //input only form elements
         let timer;
         const timeoutVal = 1750, // time it takes to wait for user to stop typing in ms
            keyPressTab = 9,
            keyPressShift = 16;

         inputformSelector.on('keyup', function (e) {
            const keyCodePress = (e.keyCode ? e.keyCode : e.which);
            if (keyCodePress != keyPressShift) {
               if (keyCodePress != keyPressTab) {
                  handleKeyUp($(this).attr('id'));
               }
            }
         });

         inputformSelector.on('keypress', function (e) {
            const keyCodePress = (e.keyCode ? e.keyCode : e.which);
            if (keyCodePress != keyPressShift) {
               if (keyCodePress != keyPressTab) {
                  handleKeyPress();
               }
            }
         });

         function handleKeyPress() {
            window.clearTimeout(timer);
         }

         function handleKeyUp(thisID) {
            window.clearTimeout(timer);
            timer = window.setTimeout(() => {
               _form.ValidationInfo.forEach(function (item) {
                  if (item.targetElementId === thisID) {
                     validateElement(item.targetElementName, item.validators, $("#" + item.targetElementId).val());
                  }
               });
            }, timeoutVal);
         }

         //three field date fielD
         newDateFieldSelector.on('focusout', function () {
            const thisID = $(this).parents('div[data-form-element-date]').find('input[type=hidden]').attr('id');
            const thisFieldName = $(this).parents('.FormTextbox').attr('data-f-element-name');
            setTimeout(function () {
               const activeFieldName = $(document.activeElement).parents('.FormTextbox').attr('data-f-element-name');
               _form.ValidationInfo.forEach(function (item) {
                  if (item.targetElementId === thisID && activeFieldName != thisFieldName) {
                     validateSplitDateElement(item.targetElementName, item.validators, $("#" + item.targetElementId).val());
                  }
               });
            }, 10);
         });

         //checkbox/radio specific
         radioCheckboxSelector.each(function () {
            if ($(this).is(':checked')) {
               const inputType = $(this).attr('type');
               pushValuesToFieldSet(this, inputType);
            }
         });

         radioCheckboxSelector.on('change', function (event) {
            const inputType = $(this).attr('type'),
               thisParentsID = $(this).parents('.Form__Element.FormChoice').attr('id');

            pushValuesToFieldSet(this, inputType);

            _form.ValidationInfo.forEach(function (item) {
               if (item.targetElementId === thisParentsID) {
                  validateElement(item.targetElementName, item.validators, $("#" + item.targetElementId + " fieldset").attr('data-hasvalue'));
               }
            });
         });

         radioCheckboxSelector.on('focusin', function () {
            focusWithinParent(this, "add");
         });

         radioCheckboxSelector.on('focusout', function (event) {
            const thisParentsID = $(this).parents('.Form__Element.FormChoice').attr('id');
            const thisParentsEl = $("#" + thisParentsID);
            let focusLeftParent = false;

            focusWithinParent(this, "remove");

            setTimeout(function () {

               if (thisParentsEl.find(".checkgroupcontainer").hasClass("focuswithin")) {
                  focusLeftParent = false;
               } else {
                  focusLeftParent = true;
               }

               _form.ValidationInfo.forEach(function (item) {
                  if (focusLeftParent && item.targetElementId === thisParentsID) {
                     const shorthandHasValue = $("#" + item.targetElementId + " fieldset").attr('data-hasvalue');
                     const hasValue = shorthandHasValue != null ? shorthandHasValue : "";
                     validateElement(item.targetElementName, item.validators, hasValue);
                  }
               });
            }, 150);
         });
      }

      function validateSplitDateElement(elementName, lstValidator, whatToCheck) {
         const _validationSvc = epi.EPiServer.Forms.Validation,
            results = _validationSvc.validateFormValue(elementName, whatToCheck, lstValidator),
            errorElement = $(".Form__Element__ValidationError[data-f-linked-name='" + elementName + "']"),
            formElementParent = $(".Form__Element[data-f-element-name='" + elementName + "']"),
            formElement = formElementParent.find('.formelement'),
            defaultMessage = 'This field is required.';

         let isValid = true;

         results.forEach(function (item, index) {
            if (index == 0) {
               errorElement.text('');
            }

            if (item.message === defaultMessage) {
               ///ignore the default required validator on this element type
            }
            else if (!item.isValid) {
               errorElement.append(item.message + ' ');
               errorElement.show();
               formElement.attr('aria-invalid', 'true');
               formElementParent.addClass("ValidationFail");
               isValid = false;
               formElementParent.find('.FormTextbox__Input.datefield').attr('aria-invalid', 'true');

            }
         });
         if (isValid) {
            errorElement.text();
            errorElement.hide();
            formElement.removeAttr('aria-invalid');
            formElementParent.removeClass('ValidationFail');
            formElementParent.find('.FormTextbox__Input.datefield').removeAttr('aria-invalid');
         }
      }

      function validateElement(elementName, lstValidator, whatToCheck) {
         const _validationSvc = epi.EPiServer.Forms.Validation,
            results = _validationSvc.validateFormValue(elementName, whatToCheck, lstValidator),
            errorElement = $(".Form__Element__ValidationError[data-f-linked-name='" + elementName + "']"),
            formElementParent = $(".Form__Element[data-f-element-name='" + elementName + "']"),
            formElement = formElementParent.find('.formelement');

         let isValid = true;


         results.forEach(function (item) {
            if (!item.isValid) {
               errorElement.text(item.message);
               errorElement.show();
               formElement.attr('aria-invalid', 'true');
               formElementParent.addClass("ValidationFail");
               isValid = false;
            }
         });
         if (isValid) {
            errorElement.text();
            errorElement.hide();
            formElement.removeAttr('aria-invalid');
            formElementParent.removeClass('ValidationFail');
         }
      }

      function pushValuesToFieldSet(el, inputtype) {
         const thisEl = $(el),
            valueEl = thisEl.val(),
            parentEl = thisEl.parents('fieldset'),
            dataName = 'data-hasvalue',
            groupSelector = thisEl.parents('.Form__Element.FormChoice').find('input.formelement');

         let dataGroupArray = [];

         if (inputtype == 'checkbox') {
            parentEl.attr(dataName, "");
            dataGroupArray = []
            groupSelector.each(function (index) {
               if ($(this).is(':checked')) {
                  dataGroupArray.push($(this).val());
               }
            });
            parentEl.attr(dataName, dataGroupArray);
         }

         if (inputtype == 'radio' && thisEl.is(':checked')) {
            parentEl.attr(dataName, valueEl);
         }
         else if (inputtype == 'radio') {
            parentEl.attr(dataName, '');
         }
      }

      function focusWithinParent(el, event) {
         const parentSelector = $(el).parents('.checkgroupcontainer'),
            idClass = 'focuswithin';

         if (event == 'add') {
            parentSelector.addClass(idClass);
         }
         else if (event == 'remove') {
            parentSelector.removeClass(idClass);
         }
      }

   }
}(jQuery));
